import { Column } from 'new/elements/Table/types';
import DateUtils from 'js/lib/DateUtils';

export const columns = [
  {
    name: 'IP Address',
    field: 'request_ip',
    width: 30,
  },
  {
    name: 'Event',
    field: 'type',
    renderRow: (row) => {
      if (row.type === 'login') return 'Login';
      return 'Logout';
    },
  },
  {
    name: 'Date/Time',
    field: 'time_of_issue',
    renderRow: (row) => {
      let time = row.time_of_issue;
      if (row.type === 'logout') {
        time = row.time_of_invalidation;
      }
      return DateUtils.getDateString(time, 'YYYY-MM-DD HH:mm:ss z');
    },
  },
] as Column<any>[];
